"use strict";
import { __require as p } from "./index.es325.js";
import { __require as t } from "./index.es103.js";
import { __require as o } from "./index.es324.js";
import { __require as c } from "./index.es406.js";
var e, i;
function m() {
  if (i) return e;
  i = 1;
  var l = p(), n = /* @__PURE__ */ t(), u = o(), a = c();
  return e = function(r) {
    if (r.length < 1 || typeof r[0] != "function")
      throw new n("a function is required");
    return a(l, u, r);
  }, e;
}
export {
  m as __require
};
//# sourceMappingURL=index.es327.js.map
